module.exports = __webpack_public_path__ + "static/HuggiesSample-28ab47739f34daa39109c971ea8ef47a.jpg";